<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <div class="sidebar-logo">
      <a href="https://ng.ant.design/" target="_blank">
        <!-- <img src="https://ng.ant.design/assets/img/logo.svg" alt="logo"> -->
        <h1>WATERMARK CODE</h1>
      </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- <li nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/welcome">Welcome</a>
          </li>
          <li nz-menu-item nzMatchRouter>
            <a>Monitor</a>
          </li>
          <li nz-menu-item nzMatchRouter>
            <a>Workplace</a>
          </li>
        </ul>
      </li> -->
      <li nz-submenu nzOpen nzTitle="MASTER" nzIcon="form">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/partner">Đối Tác</a>
          </li>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/codelist">Mã QR</a>
          </li>
        </ul>
      </li>
      <li *ngIf="userInfo && userInfo.role =='admin'" nz-submenu nzOpen nzTitle="Thiết Lập Chung" nzIcon="form">
        <ul>
          <li *ngIf="userInfo && userInfo.role =='admin'" nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/user">Người Dùng</a>
          </li>
          <li *ngIf=" userInfo && userInfo.role =='admin'" nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/company">Công Ty</a>
          </li>
          <li *ngIf="userInfo && userInfo.role =='admin'" nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/department">Phòng Ban</a>
          </li>
          <li *ngIf="userInfo && userInfo.role =='admin'" nz-menu-item nzMatchRouter>
            <a routerLink="/main/masterdata/configgeneral">Thiết Lập Chung</a>
          </li>
        </ul>
      </li>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <div style="width: 100%;height: 100%;display: flex;
        justify-content: space-between;
        align-items: center;">
          <div class="header-trigger" (click)="isCollapsed = !isCollapsed" style="display: flex;
          justify-content: space-between;
          align-items: center;">
            <i class="trigger icon-size20" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
          </div>
          <div style="display: flex;flex: 1;height: 100%;justify-content: flex-end;align-items: center;padding-right: 40px;">
           <div class="text-user-hello">Xin chào</div>
           <div class="text-user">{{userInfo.firstName}}, {{userInfo.lastName}} </div>
            <button (click)="logout($event)" nz-button nzType="primary" nzGhost [nzSize]="'large'"><i nz-icon
                nzType="logout" nzTheme="outline" class="icon-size20 primary-color"></i></button>
          </div>
        </div>

      </div>

    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>